import React from "react";

interface TableLoaderProps {
    colCount: number;       // number of table columns
}

export const TableLoader: React.FC<TableLoaderProps> = ({ colCount }) => {
    return(
         <>
            <tr style={{ height: 100 }}>
                <td colSpan={colCount} className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </td>
            </tr>
        </>
    );
}